<template>
  <main>
    <CardInfo/>
    <FilmList
      :has-card="hasCard"
      :card="card"
      type="film"
      @checked="onChecked"
      @cancel="onCancel"/>
    <!-- <van-submit-bar
      v-show="hasList"
      :price="checkedList.price"
      :disabled="checkedList.price <= 0 || checkedList.imageIds.length <= 0"
      button-text="购买胶片"
      @submit="handleOnSubmit"
    /> -->
    <div class="fixed-bottom d-flex">
      <span
        class="flex-grow-1"
        style="background-color: #fff;"></span>
      <span
        v-show="checkedList.price !== originalPrice"
        class="original-price">
        <del>合计: {{ (originalPrice / 100).toFixed(2) }} 元</del>
      </span>
      <span class="price">
        {{ checkedList.price === originalPrice ? '合计' : '推广价' }}:
        {{ (checkedList.price / 100).toFixed(2) }} 元
      </span>
      <van-button
        :disabled="checkedList.price <= 0 || checkedList.imageIds.length <= 0"
        type="danger"
        class="rounded-0"
        @click="handleOnSubmit">购买胶片</van-button>
    </div>
  </main>
</template>

<script>
import bus from '@/libs/bus';

const CardInfo = () => import('@/components/CardInfo.vue');
const FilmList = () => import('@/components/FilmList.vue');

export default {
  name: 'Film',
  components: {
    CardInfo,
    FilmList,
  },
  data() {
    return {
      checked: new Map(),
      checkedList: {
        imageIds: [],
        price: 0, // 推广价
      },
      originalPrice: 0,
      hasCard: false,
      hasList: false,
      card: {},
    };
  },
  mounted() {
    bus.$on('load-card', (status, value) => {
      this.hasCard = status;
      if (status) {
        this.card = value;
      }
    });
    bus.$on('load-list', (value) => {
      this.hasList = value;
    });
    bus.$on('change', () => {
      this.checked.clear();
      this.setCheckedList();
    });
  },
  activated() {
    this.originalPrice = 0;
  },
  methods: {
    setCheckedList() {
      const map = this.checked;
      const imageIds = [];
      let price = 0;
      if (map.size > 0) {
        map.forEach((value, key) => {
          imageIds.push(key);
          price += value;
        });
      }
      this.checkedList = {
        imageIds,
        price,
      };
    },
    async handleOnSubmit() {
      const response = await this.$http.post('/cloud-film-api/webapi/bill/create-bill', {
        image_ids: this.checkedList.imageIds.join(','),
      });
      // this.$router.push({
      //   name: 'payment',
      //   params: { id: response.bill_code },
      // });
      window.location.href = `/cloud-film/payment?billCode=${response.bill_code}`;
    },
    onChecked(value) {
      const price = value.current_price; // 推广价
      const imageId = value.patient_info.image_id;
      const map = this.checked;
      this.originalPrice += value.price;
      map.set(imageId, price);
      this.checked = map;
      this.setCheckedList();
    },
    onCancel(value) {
      const imageId = value.patient_info.image_id;
      this.originalPrice -= value.price;
      this.checked.delete(imageId);
      this.setCheckedList();
    },
  },
};
</script>

<style lang="scss" scoped>
  .price {
    background-color: #fff;
    line-height: 44px;
    padding-right: 12px;
    color: #f44;
    text-align: right;
  }

  .original-price {
    background-color: #fff;
    line-height: 44px;
    // font-size: 14px;
    text-align: right;
    padding-right: 4px;
  }
</style>
